module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.stats.black-3dcf3cf066aedad43bbfa7e2e1389007.svg";